<template id="DownloadLog">

    <div class="pantalla">
        <div class="row">
            <h3>Bitácora de descargas de comprobantes de pago de empleados</h3>
            <hr class="red" style="margin-bottom: 0">

            <div class="col-md-3"/>
            <form v-on:submit.prevent="buscar();" class="form-horizontal col-md-6" role="form">

                <!-- modal para la carga -->
                <loading :active.sync="isLoading"
                         color="#9D2449" background-color="#CCCCCC" />

                <div class="form-group">
                    <center>
                        <h3>Criterios de búsqueda</h3>
                        <label>
                            <input type="radio" name="radio-01" value="opcion-01" @click="cleanInput2(); tipoBusqueda = false" checked="checked"> Id Empleado
                        </label>
                        <label style="margin-left: 15px">
                            <input type="radio" name="radio-01" value="opcion-02"  @click="cleanInput(); tipoBusqueda = true"> RFC Empleado
                        </label>
                        <input class="form-control" id="idEmpleado" type="number" v-model="v_idEmp" v-show="!tipoBusqueda"
                               @change="setAnio();" placeholder="Ingrese ID del empleado"  >
                        <input class="form-control" id="rfc" type="text" v-model="v_rfc" v-show="tipoBusqueda"
                               @change="setAnio();" placeholder="Ingrese RFC del empleado" >
                    </center>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label" for="email-03">Año:</label>
                    <div class="col-sm-3">
                        <select class="form-control" v-model="v_anio" v-on:change="setQuincena($event.target.value)" style="min-width:140px">
                            <option value="" selected>Seleccionar</option>
                            <option :key="anioOption +1" v-for="anioOption in anios" v-bind:value="anioOption"> {{ anioOption}}</option>
                        </select>
                    </div>
                    <label class="col-sm-3 control-label" for="email-03">Quincena:</label>
                    <div class="col-sm-3">
                        <select class="form-control" v-model="v_quincena" style="min-width:150px">
                            <option value="" selected>Seleccionar</option>
                            <option :key="quincenaOption +1" v-for="quincenaOption in quincenas" v-bind:value="quincenaOption"> {{ quincenaOption}}</option>
                        </select>
                    </div>
                </div>
                <div class="text-center">
                    <!-- Botón de error -->
                    <button type="button" class="btn btn-danger" style="margin: 5px" v-on:click="clean">Limpiar</button>

                    <!-- Botón primario -->
                    <button type="submit" class="btn btn-primary" style="margin: 5px">Buscar
                    </button>
                </div>
            </form>
            <div class="col-md-3"/>
            
        </div>
        <div v-if="show" class="row" style="margin-top: 20px; margin-bottom: 20px">
            <h4 style="font-family: Arial">Descargas encontradas</h4>
            <hr class="red" style="margin-bottom: 15px">
            <table class="table table-striped table-responsive">
                <thead>
                    <tr>
                        <th class="text-center">Id empleado</th>
                        <th class="text-center">Fecha de descarga
                        <th class="text-center">Fecha de aceptación del aviso de privacidad</th>
                        <th class="text-center">Ejercicio</th>
                        <th class="text-center">Periodo de pago</th>    
                        <th class="text-center">Quincena</th>
                        <th class="text-center">Tipo archivo</th>
                        <th class="text-center">Observación</th>
                    </tr>
                </thead>
                <tbody v-if="bitacora != ''">
                    <tr v-for="bitac in bitacora" v-bind:key="bitac.idDownload">
                        <td class="text-center">{{bitac.iNumEmpleado}}</td>
                        <td class="text-center">{{bitac.tsRegistro}}</td>
                        <td class="text-center">{{bitac.dtFechaAcepAvPriv}}</td>
                        <td class="text-center">{{bitac.ejercicio}}</td>
                        <td class="text-center">{{bitac.periodoPago}}</td>
                        <td class="text-center">{{bitac.quincena}}</td>
                        <td class="text-center">{{bitac.tipoArchivo}}</td>
                        <td class="text-center">{{bitac.observacion}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr><td colspan="8">No existen resultados con los parametros seleccionados</td></tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Vue from 'vue';

    export default {
        name: "DownloadLog",
        data() {
            return {
                show: false,
                anio: '',
                quincenas: [],
                anios: [],
                bitacora: [],
                v_anio: '',
                v_quincena: '',
                v_rfc: '',
                v_idEmp: '',
                tipoBusqueda: false,
                nombreEmleado: '',
                idEmpleadoLogueado: '',
                rfcEmpleadologueado: '',
                isLoading: false
            }
        },
        methods: {
            buscar(){

                this.isLoading = true;

                axios.post(Vue.prototype.$globalHost + '/consultaBitacoraDescarga',{
                    idEmpleado : this.v_idEmp,
                    rfc: this.v_rfc,
                    anio: this.v_anio,
                    quincena: this.v_quincena,
                    idEmpleadoLogueado : this.idEmpleadoLogueado
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.bitacora = response.data;
                    this.show = true;
                    this.isLoading = false;
                })
                .catch(error => {

                    this.show = false;
                    this.isLoading = false;
                    this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al buscar la información de las descargas de comprobantes')
                })
            },
            setAnio() {

                this.v_anio = '';
                this.anios = [];
                this.v_quincena = '';
                this.quincenas = [];
                this.isLoading = true;

                axios.post(Vue.prototype.$globalHost + '/consultaAniosBitacora',{
                    idEmpleado: this.v_idEmp,
                    rfc: this.v_rfc
                },{
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.anios = response.data;
                    this.isLoading = false;
                })
                .catch(error => {
                    
                    this.isLoading = false;
                    this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al obtener la información de los posibles años a seleccionar')
                })
            },
            setQuincena(anioSeleccionado){

                this.v_quincena = '';
                this.quincenas = [];
                this.isLoading = true;
                
                axios.post(Vue.prototype.$globalHost + '/consultaQuincenasBitacora',{
                    anio: anioSeleccionado,
                    idEmpleado: this.v_idEmp,
                    rfc: this.v_rfc
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.quincenas = response.data;
                    this.isLoading = false;
                })
                .catch(error => {

                    this.isLoading = false;
                    this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al obtener la información de las posibles quincenas a seleccionar')
                })
            },
            clean(){
                this.v_anio = ''
                this.v_quincena = ''
                this.v_rfc = ''
                this.v_idEmp = ''
                this.bitacora = []
                this.anios = []
                this.quincenas = []
                this.show = false
            },
            cleanInput() {
                this.v_idEmp = ''
                this.v_anio = ''
                this.v_quincena = ''
                this.anios = []
                this.quincenas = []
                document.getElementById("rfc").required = true
                document.getElementById("idEmpleado").required = false
            },
            cleanInput2() {
                this.v_rfc = ''
                this.v_anio = ''
                this.v_quincena = ''
                this.anios = []
                this.quincenas = []
                document.getElementById("rfc").required = false
                document.getElementById("idEmpleado").required = true
            }
        },
        mounted() {
            
            this.nombreEmleado = localStorage.getItem('name');
            this.idEmpleadoLogueado = localStorage.getItem('user_id');
            this.rfcEmpleadologueado = localStorage.getItem('user_rfc');
            document.getElementById("idEmpleado").required = true
        }
    }
</script>